import { Box } from '@hover/blueprint';
import React from 'react';
import TextContent from './TextContent';
import Carousel from './Carousel';

const DesignOrdersHero = () => (
  <Box
    w="100%"
    h={{ base: 'auto', desktop: '763px' }}
    flexDir="column"
    alignItems="center"
  >
    <TextContent />
    <Carousel />
  </Box>
);

export default DesignOrdersHero;
